import QuestionGeneratorHelper from '../core/question_generator_helper.js'
import GeoScreen from './geometry/geo_screen.js'

QuestionGeneratorHelper.prototype.addGeoScreen = function (params = {}) {
    params.container = this.container
    const geoScreen = new GeoScreen(params)
    this.todoOnDisplay.push(function (done) {
        geoScreen.drawAll(params)
        done()
    })
    return geoScreen
}


QuestionGeneratorHelper.textFilters.push(function (string) {
    return string.replace(/VECTOR\(([^)]*)\)/g, function (fullMatch, name) {
        let html_class = (name.length === 1 ? 'one_letter' : 'two_letters')
        return '<span class="vector_name">' + name +
            '<span class="' + html_class + '_vector_arrow">&rarr;</span>' +
            '</span>'
    })
})


